var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-progress-linear',{attrs:{"value":_vm.progress,"color":_vm.colour}})}
var staticRenderFns = []

export { render, staticRenderFns }